import React from "react";

const iacClasses = [
  { code: 10, label: "Nuages", color: "rgb(0,0,0)", def: "Surface non classifiée à cause des nuages, ombrage ou autres facteurs de qualité d’image" },
  { code: 20, label: "Eau", color: "rgb(51,51,255)", def: "Plan d’eau (lacs, réservoirs, rivières, etc.)" },
  { code: 30, label: "Sols nus/terres stériles", color: "rgb(153,102,102)", def: "Terre principalement non végétalisée et non développée." },
  { code: 34, label: "Milieu urbain/bâti", color: "rgb(204,102,153)", def: "Terre principalement construite ou développée." },
  { code: 35, label: "Serres", color: "rgb(225,225,225)", def: "Les serres sont identifiées par interprétation satellite." },
  { code: 50, label: "Arbustaie", color: "rgb(255,255,0)", def: "Surface couverte de végétations ligneuses." },
  { code: 60, label: "Incendie de forêt / zone brûlée", color: "rgb(102,102,102)", def: "Terre ayant subi des incendies." },
  { code: 80, label: "Terres humides", color: "rgb(153,51,153)", def: "Terres humides ou aquatiques." },
  { code: 85, label: "Tourbière exploitée", color: "rgb(80,27,80)", def: "Tourbière exploitée commercialement." },
  { code: 110, label: "Prairies", color: "rgb(204,204,0)", def: "Herbes indigènes et autre végétation herbacée." },
  { code: 120, label: "Agriculture (indifférenciée)", color: "rgb(204,102,0)", def: "Terres agricoles annuelles et pérennes." },
  { code: 122, label: "Pâturage/Cultures fourragères", color: "rgb(255,204,51)", def: "Herbes cultivées et autres cultures fourragères." },
  { code: 130, label: "Trop humide pour l’ensemencement", color: "rgb(120,153,246)", def: "Champs non ensemencés pour excès d’humidité." },
  { code: 131, label: "Jachère", color: "rgb(255,153,0)", def: "Champs labourés non semés." },
  { code: 132, label: "Céréales", color: "rgb(102,0,0)", def: "Sous-céréales non distinguées." },
  { code: 133, label: "Orge", color: "rgb(218,227,29)", def: "Orge" },
  { code: 134, label: "Autres céréales", color: "rgb(153,204,0)", def: "Autres céréales" },
  { code: 135, label: "Millet", color: "rgb(210,219,37)", def: "Millet" },
  { code: 136, label: "Avoine", color: "rgb(209,213,43)", def: "Avoine" },
  { code: 137, label: "Seigle", color: "rgb(202,206,50)", def: "Seigle" },
  { code: 138, label: "Épeautre", color: "rgb(195,198,58)", def: "Épeautre" },
  { code: 139, label: "Triticale", color: "rgb(185,188,68)", def: "Triticale" },
  { code: 140, label: "Blé", color: "rgb(167,179,77)", def: "Blé" },
  { code: 141, label: "Panic érigé", color: "rgb(185,198,78)", def: "Panic érigé" },
  { code: 142, label: "Sorgho", color: "rgb(153,153,0)", def: "Sorgho" },
  { code: 143, label: "Quinoa", color: "rgb(233,226,177)", def: "Quinoa" },
  { code: 145, label: "Blé d’hiver", color: "rgb(128,161,105)", def: "Blé d’hiver" },
  { code: 146, label: "Blé de printemps", color: "rgb(146,165,91)", def: "Blé de printemps" },
  { code: 147, label: "Maïs", color: "rgb(255,255,126)", def: "Maïs" },
  { code: 148, label: "Tabac", color: "rgb(152,136,124)", def: "Tabac" },
  { code: 149, label: "Ginseng", color: "rgb(121,155,147)", def: "Ginseng" },
  { code: 150, label: "Oléagineux", color: "rgb(94,162,99)", def: "Oléagineux" },
  { code: 151, label: "Bourrache", color: "rgb(82,174,119)", def: "Bourrache" },
  { code: 152, label: "Caméline", color: "rgb(65,191,122)", def: "Caméline" },
  { code: 153, label: "Canola/Colza", color: "rgb(214,255,145)", def: "Canola/Colza" },
  { code: 154, label: "Lin", color: "rgb(140,140,255)", def: "Lin" },
  { code: 155, label: "Moutarde", color: "rgb(214,204,0)", def: "Moutarde" },
  { code: 156, label: "Carthame", color: "rgb(255,127,0)", def: "Carthame" },
  { code: 157, label: "Tournesol", color: "rgb(49,84,145)", def: "Tournesol" },
  { code: 158, label: "Soya", color: "rgb(204,153,51)", def: "Soya" },
  { code: 160, label: "Légumineuses", color: "rgb(137,110,67)", def: "Légumineuses" },
  { code: 161, label: "Autres Légumineuses", color: "rgb(153,102,51)", def: "Autres Légumineuses" },
  { code: 162, label: "Pois", color: "rgb(143,108,61)", def: "Pois" },
  { code: 163, label: "Pois Chiche", color: "rgb(182,134,61)", def: "Pois Chiche" },
  { code: 164, label: "Haricots", color: "rgb(130,101,105)", def: "Haricots" },
  { code: 168, label: "Féveroles", color: "rgb(163,144,105)", def: "Féveroles" },
  { code: 174, label: "Lentilles", color: "rgb(184,89,0)", def: "Lentilles" },
  { code: 175, label: "Légumes", color: "rgb(183,75,21)", def: "Légumes" },
  { code: 176, label: "Tomates", color: "rgb(255,138,138)", def: "Tomates" },
  { code: 177, label: "Pomme de terre", color: "rgb(255,204,204)", def: "Pomme de terre" },
  { code: 178, label: "Betterave à sucre", color: "rgb(111,85,202)", def: "Betterave à sucre" },
  { code: 179, label: "Autres légumes", color: "rgb(255,204,255)", def: "Autres légumes" },
  { code: 180, label: "Fruits", color: "rgb(220,84,36)", def: "Fruits" },
  { code: 181, label: "Petits fruits", color: "rgb(208,90,48)", def: "Petits fruits" },
  { code: 182, label: "Bleuet", color: "rgb(210,0,0)", def: "Bleuet" },
  { code: 183, label: "Canneberge", color: "rgb(204,0,0)", def: "Canneberge" },
  { code: 185, label: "Autres baie", color: "rgb(220,50,0)", def: "Autres baie" },
  { code: 188, label: "Vergers", color: "rgb(255,102,102)", def: "Vergers" },
  { code: 189, label: "Autres fruits", color: "rgb(197,69,69)", def: "Autres fruits" },
  { code: 190, label: "Vignobles", color: "rgb(116,66,189)", def: "Vignobles" },
  { code: 191, label: "Houblon", color: "rgb(255,204,153)", def: "Houblon" },
  { code: 192, label: "Gazon en plaques", color: "rgb(181,251,5)", def: "Gazon en plaques" },
  { code: 193, label: "Fines herbes", color: "rgb(204,255,5)", def: "Fines herbes" },
  { code: 194, label: "Pépinière", color: "rgb(7,249,140)", def: "Pépinière" },
  { code: 195, label: "Sarrasin", color: "rgb(0,255,204)", def: "Sarrasin" },
  { code: 196, label: "Graines à canaris", color: "rgb(204,51,204)", def: "Graines à canaris" },
  { code: 197, label: "Chanvre", color: "rgb(142,118,144)", def: "Chanvre" },
  { code: 198, label: "Vesce", color: "rgb(177,149,79)", def: "Vesce" },
  { code: 199, label: "Autres cultures", color: "rgb(116,154,102)", def: "Autres cultures" },
  { code: 200, label: "Forêt (indifférenciée)", color: "rgb(0,153,0)", def: "Forêts ou zones majoritairement boisées." },
  { code: 210, label: "Forêt de conifères", color: "rgb(0,102,0)", def: "Forêts ou zones boisées principalement de conifères." },
  { code: 220, label: "Forêt de feuillus", color: "rgb(0,204,0)", def: "Principalement feuillus." },
  { code: 230, label: "Forêt mixte", color: "rgb(204,153,0)", def: "Combinaison de conifères et feuillus." }
];

export default function IACLegend({ layer }) {
  // Affiche la légende pour toutes les couches IAC (avec tiret ou underscore)
  if (
    !layer ||
    (
      !layer.startsWith("Projet_MOS_Essai:IAC-") &&
      !layer.startsWith("Projet_MOS_Essai:IAC_")
    )
  ) return null;

  return (
    <div
      className="legend-panel"
      style={{
        padding: "1em",
        background: "#fff",
        borderRadius: "8px",
        maxHeight: "800px",
        overflowY: "auto",
        width: "140px",
        minWidth: "120px"
      }}
    >
      <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
        {iacClasses.map(({ code, label, color, def }) => (
          <li key={code} style={{ display: "flex", alignItems: "center", marginBottom: "0.5em" }}>
            <span
              style={{
                display: "inline-block",
                width: "18px",
                height: "14px",
                background: color,
                border: "1px solid #232b21",
                borderRadius: "3px",
                marginRight: "0.7em"
              }}
              title={def}
            ></span>
            <span style={{ color: "#232b21", fontSize: "0.8em", fontWeight: "bold", width: "80px" }}>{label}</span>
            <span style={{ color: "#666", fontSize: "0.75em", width: "30px" }}>({code})</span>
          </li>
        ))}
      </ul>
    </div>
  );
}